// extracted by mini-css-extract-plugin
export default {"dropdown-basic":"sidebar_dropdown-basic__TxgXz"};